import { IconPropsType } from '..';

export const PhotoIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.99902 7.25C5.62402 7.25 6.15527 7.03125 6.59277 6.59375C7.03027 6.15625 7.24902 5.625 7.24902 5C7.24902 4.375 7.03027 3.84375 6.59277 3.40625C6.15527 2.96875 5.62402 2.75 4.99902 2.75C4.37402 2.75 3.84277 2.96875 3.40527 3.40625C2.96777 3.84375 2.74902 4.375 2.74902 5C2.74902 5.625 2.96777 6.15625 3.40527 6.59375C3.84277 7.03125 4.37402 7.25 4.99902 7.25ZM4.99902 6.25C4.64902 6.25 4.35319 6.12917 4.11152 5.8875C3.86986 5.64583 3.74902 5.35 3.74902 5C3.74902 4.65 3.86986 4.35417 4.11152 4.1125C4.35319 3.87083 4.64902 3.75 4.99902 3.75C5.34902 3.75 5.64486 3.87083 5.88652 4.1125C6.12819 4.35417 6.24902 4.65 6.24902 5C6.24902 5.35 6.12819 5.64583 5.88652 5.8875C5.64486 6.12917 5.34902 6.25 4.99902 6.25ZM0.999023 9C0.724023 9 0.488607 8.90208 0.292773 8.70625C0.0969401 8.51042 -0.000976562 8.275 -0.000976562 8V2C-0.000976562 1.725 0.0969401 1.48958 0.292773 1.29375C0.488607 1.09792 0.724023 1 0.999023 1H2.57402L3.49902 0H6.49902L7.42402 1H8.99902C9.27402 1 9.50944 1.09792 9.70527 1.29375C9.90111 1.48958 9.99902 1.725 9.99902 2V8C9.99902 8.275 9.90111 8.51042 9.70527 8.70625C9.50944 8.90208 9.27402 9 8.99902 9H0.999023ZM0.999023 8H8.99902V2H6.97402L6.06152 1H3.93652L3.02402 2H0.999023V8Z"
        fill="#E3E3E3"
      />
    </svg>
  );
};
